import {Route, Routes} from "react-router-dom";
import List from "./List";
import Post from "./Post";
import Detail from "./Detail";
import Edit from "./Edit";
import {RouterProps} from "../../RouterProps";

export default function PolicyRouter(props: RouterProps) {
    return <>
        <Routes>
            <Route path={'/'} element={<List {...props} />} />
            <Route path={'/post'} element={<Post {...props} />} />
            <Route path={'/:uiPolicyId'} element={<Detail {...props} />} />
            <Route path={'/:uiPolicyId/edit'} element={<Edit {...props} />} />
        </Routes>
    </>
}